// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EKV5","importantInfo":"styles_importantInfo__IQDo6"};